import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { HermesRoutes } from "@hermes/utils-generic/constants";

import { HomePageComponent } from "./components/home-page.component";
import { HomePageResolver } from "./resolvers/home-page.resolver";

export const homePageRoutes: HermesRoutes[] = [
    {
        path: "",
        pathMatch: "full",
        component: HomePageComponent,
        resolve: {
            story: HomePageResolver,
        },
    },
];
@NgModule({
    imports: [RouterModule.forChild(homePageRoutes)],
    exports: [RouterModule],
    providers: [HomePageResolver],
})
export class HomepageRoutingModule {}
